// AUTO-GENERATED by packages/server/scripts/gen_real_battle.ts.
// Edit the generator's curated teams + seed, then re-run the script
// to regenerate this file. Do not hand-edit the event_log below.
//
// This fixture is the end-to-end validation that the live simulator
// produces a replay the BattleScreen can play through without crashes.

import { BattleResultSchema, type BattleResult } from '@origami/shared'

const raw: BattleResult = {
  "winner": "A",
  "surviving_count": 1,
  "event_log": [
    {
      "turn": 0,
      "type": "battle_start",
      "teams": {
        "A": [
          {
            "ref": "A:1",
            "unit_id": "cinder_wyrm",
            "star": 1,
            "hp": 8,
            "atk": 7,
            "position": 1
          },
          {
            "ref": "A:2",
            "unit_id": "acorn_bear",
            "star": 1,
            "hp": 9,
            "atk": 3,
            "position": 2
          },
          {
            "ref": "A:3",
            "unit_id": "stream_smelt",
            "star": 1,
            "hp": 3,
            "atk": 1,
            "position": 3
          }
        ],
        "B": [
          {
            "ref": "B:1",
            "unit_id": "marsh_caiman",
            "star": 1,
            "hp": 3,
            "atk": 4,
            "position": 1
          },
          {
            "ref": "B:2",
            "unit_id": "storm_hawk",
            "star": 1,
            "hp": 6,
            "atk": 5,
            "position": 2
          },
          {
            "ref": "B:3",
            "unit_id": "paper_mite",
            "star": 1,
            "hp": 3,
            "atk": 2,
            "position": 3
          }
        ]
      }
    },
    {
      "turn": 0,
      "type": "trigger_fired",
      "source": "B:3",
      "trigger": "passive",
      "effect": "A humble paper mite. Tiny but persistent."
    },
    {
      "turn": 0,
      "type": "trigger_fired",
      "source": "B:2",
      "trigger": "on_unfold",
      "effect": "On battle start, strike the two rearmost enemies for this unit's ATK."
    },
    {
      "turn": 0,
      "type": "damage",
      "source": "B:2",
      "target": "A:3",
      "amount": 5,
      "new_hp": -2
    },
    {
      "turn": 0,
      "type": "damage",
      "source": "B:2",
      "target": "A:1",
      "amount": 5,
      "new_hp": 3
    },
    {
      "turn": 0,
      "type": "trigger_fired",
      "source": "A:1",
      "trigger": "on_unfold",
      "effect": "On battle start, deal 1 damage to all enemies and apply 1 stack of scorched to each."
    },
    {
      "turn": 0,
      "type": "damage",
      "source": "A:1",
      "target": "B:1",
      "amount": 1,
      "new_hp": 2
    },
    {
      "turn": 0,
      "type": "damage",
      "source": "A:1",
      "target": "B:2",
      "amount": 1,
      "new_hp": 5
    },
    {
      "turn": 0,
      "type": "damage",
      "source": "A:1",
      "target": "B:3",
      "amount": 1,
      "new_hp": 2
    },
    {
      "turn": 0,
      "type": "status_applied",
      "target": "B:1",
      "status": "scorched",
      "stacks": 1
    },
    {
      "turn": 0,
      "type": "status_applied",
      "target": "B:2",
      "status": "scorched",
      "stacks": 1
    },
    {
      "turn": 0,
      "type": "status_applied",
      "target": "B:3",
      "status": "scorched",
      "stacks": 1
    },
    {
      "turn": 1,
      "type": "turn_start"
    },
    {
      "turn": 1,
      "type": "strike",
      "source": "A:1",
      "target": "B:1",
      "damage": 5,
      "multiplier": 0.75
    },
    {
      "turn": 1,
      "type": "strike",
      "source": "B:1",
      "target": "A:1",
      "damage": 5,
      "multiplier": 1.25
    },
    {
      "turn": 1,
      "type": "status_expired",
      "target": "B:1",
      "status": "scorched"
    },
    {
      "turn": 1,
      "type": "damage",
      "source": "A:1",
      "target": "B:1",
      "amount": 6,
      "new_hp": -4,
      "multiplier": 0.75
    },
    {
      "turn": 1,
      "type": "damage",
      "source": "B:1",
      "target": "A:1",
      "amount": 5,
      "new_hp": -2,
      "multiplier": 1.25
    },
    {
      "turn": 1,
      "type": "crumple",
      "unit": "B:1"
    },
    {
      "turn": 1,
      "type": "crumple",
      "unit": "A:1"
    },
    {
      "turn": 1,
      "type": "crumple",
      "unit": "A:3"
    },
    {
      "turn": 1,
      "type": "slide_forward",
      "team": "A",
      "new_order": [
        "A:2"
      ]
    },
    {
      "turn": 1,
      "type": "slide_forward",
      "team": "B",
      "new_order": [
        "B:2",
        "B:3"
      ]
    },
    {
      "turn": 1,
      "type": "turn_end"
    },
    {
      "turn": 2,
      "type": "turn_start"
    },
    {
      "turn": 2,
      "type": "strike",
      "source": "A:2",
      "target": "B:2",
      "damage": 4,
      "multiplier": 1.25
    },
    {
      "turn": 2,
      "type": "strike",
      "source": "B:2",
      "target": "A:2",
      "damage": 4,
      "multiplier": 0.75
    },
    {
      "turn": 2,
      "type": "status_expired",
      "target": "B:2",
      "status": "scorched"
    },
    {
      "turn": 2,
      "type": "damage",
      "source": "A:2",
      "target": "B:2",
      "amount": 5,
      "new_hp": 0,
      "multiplier": 1.25
    },
    {
      "turn": 2,
      "type": "damage",
      "source": "B:2",
      "target": "A:2",
      "amount": 4,
      "new_hp": 5,
      "multiplier": 0.75
    },
    {
      "turn": 2,
      "type": "trigger_fired",
      "source": "A:2",
      "trigger": "on_creased",
      "effect": "When this unit takes damage and survives, gain +1 ATK for the battle."
    },
    {
      "turn": 2,
      "type": "stat_changed",
      "target": "A:2",
      "stat": "atk",
      "delta": 1,
      "new_value": 4,
      "permanent": true
    },
    {
      "turn": 2,
      "type": "crumple",
      "unit": "B:2"
    },
    {
      "turn": 2,
      "type": "slide_forward",
      "team": "B",
      "new_order": [
        "B:3"
      ]
    },
    {
      "turn": 2,
      "type": "turn_end"
    },
    {
      "turn": 3,
      "type": "turn_start"
    },
    {
      "turn": 3,
      "type": "strike",
      "source": "A:2",
      "target": "B:3",
      "damage": 5,
      "multiplier": 1.25
    },
    {
      "turn": 3,
      "type": "strike",
      "source": "B:3",
      "target": "A:2",
      "damage": 2,
      "multiplier": 0.75
    },
    {
      "turn": 3,
      "type": "status_expired",
      "target": "B:3",
      "status": "scorched"
    },
    {
      "turn": 3,
      "type": "damage",
      "source": "A:2",
      "target": "B:3",
      "amount": 6,
      "new_hp": -4,
      "multiplier": 1.25
    },
    {
      "turn": 3,
      "type": "damage",
      "source": "B:3",
      "target": "A:2",
      "amount": 2,
      "new_hp": 3,
      "multiplier": 0.75
    },
    {
      "turn": 3,
      "type": "trigger_fired",
      "source": "A:2",
      "trigger": "on_creased",
      "effect": "When this unit takes damage and survives, gain +1 ATK for the battle."
    },
    {
      "turn": 3,
      "type": "stat_changed",
      "target": "A:2",
      "stat": "atk",
      "delta": 1,
      "new_value": 5,
      "permanent": true
    },
    {
      "turn": 3,
      "type": "crumple",
      "unit": "B:3"
    },
    {
      "turn": 3,
      "type": "turn_end"
    },
    {
      "turn": 3,
      "type": "battle_end",
      "winner": "A",
      "surviving_count": 1
    }
  ]
}

export const realBattle: BattleResult = BattleResultSchema.parse(raw)

/** Display metadata that doesn't fit in the BattleResult schema. */
export const realBattleMeta = {
  round: 1,
  pairing: 1,
  seed: 'real-battle-v2',
  playerA: { name: 'Hokusai', tag: '@you',   maxHp: 30, hp: 30, record: '0-0', mascot: 'frog' as const },
  playerB: { name: 'Sen no Ri', tag: '@ghost', maxHp: 30, hp: 30, record: '0-0', mascot: 'tiger' as const },
  unitGlyphs: {} as Record<string, string>,
  unitNames: {} as Record<string, string>,
  unitFlying: {} as Record<string, boolean>,
  unitBodyOffsetY: {} as Record<string, number>,
  unitBodyScale: {} as Record<string, number>,
  unitElements: {} as Record<string, string>,
  unitAnimals: {} as Record<string, string>,
  nextRoundAtMs: null as number | null,
  viewerSide: 'A' as 'A' | 'B' | null,
}
